import React, { useState } from "react";
import { Phone, Check } from "lucide-react";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger, SheetDescription } from "@/components/ui/sheet";
import { useNumbers } from "@/context/NumberContext";

// Line switcher presented as a bottom sheet (mobile). `trigger` is the tap target.
export const MobileNumberSwitcher = ({ trigger }) => {
  const { numbers, selectedId, selectedNumber, setSelectedId } = useNumbers();
  const [open, setOpen] = useState(false);

  const choose = (id) => {
    setSelectedId(id);
    setOpen(false);
  };

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>{trigger}</SheetTrigger>
      <SheetContent side="bottom" className="rounded-t-2xl pb-safe" data-testid="mobile-number-sheet">
        <SheetHeader className="text-left">
          <SheetTitle className="font-heading">Changer de ligne</SheetTitle>
          <SheetDescription className="sr-only">Sélectionnez la ligne téléphonique active</SheetDescription>
        </SheetHeader>
        <div className="mt-4 space-y-1.5">
          <button
            data-testid="sheet-switch-number-all"
            onClick={() => choose("all")}
            className={`w-full flex items-center gap-3 rounded-xl border px-3 py-3 text-left transition-colors min-h-[56px] ${
              selectedId === "all" ? "border-emerald-300 bg-emerald-50/60" : "border-slate-200 bg-white active:bg-slate-50"
            }`}
          >
            <span className="h-9 w-9 rounded-lg bg-emerald-600 flex items-center justify-center shrink-0">
              <Phone className="h-4 w-4 text-white" strokeWidth={2.4} />
            </span>
            <span className="min-w-0 flex-1 leading-tight">
              <span className="block text-sm font-semibold text-slate-900 truncate">Toutes les lignes</span>
              <span className="block text-xs text-slate-400 tabular-nums truncate">Les deux numéros</span>
            </span>
            {selectedId === "all" && <Check className="h-5 w-5 text-emerald-600 shrink-0" />}
          </button>
          {numbers.map((n) => (
            <button
              key={n.id}
              data-testid={`sheet-switch-number-${n.id}`}
              onClick={() => choose(n.id)}
              className={`w-full flex items-center gap-3 rounded-xl border px-3 py-3 text-left transition-colors min-h-[56px] ${
                selectedNumber?.id === n.id ? "border-emerald-300 bg-emerald-50/60" : "border-slate-200 bg-white active:bg-slate-50"
              }`}
            >
              <span className="h-9 w-9 rounded-lg bg-emerald-600 flex items-center justify-center shrink-0">
                <Phone className="h-4 w-4 text-white" strokeWidth={2.4} />
              </span>
              <span className="min-w-0 flex-1 leading-tight">
                <span className="block text-sm font-semibold text-slate-900 truncate">{n.line_name}</span>
                <span className="block text-xs text-slate-400 tabular-nums truncate">{n.number}</span>
              </span>
              {selectedNumber?.id === n.id && <Check className="h-5 w-5 text-emerald-600 shrink-0" />}
            </button>
          ))}
        </div>
      </SheetContent>
    </Sheet>
  );
};
